/**
 * Hook for loading and saving organization settings.
 *
 * Fetches from GET /api/organizations/current
 * Saves via PUT /api/organizations/:id
 */
import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../../shared/hooks/useApi';
import { useSettingsStore } from '../store/settings-store';
export function useOrganization() {
    const [org, setOrg] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const notify = useSettingsStore((s) => s.notify);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await apiFetch('/api/organizations/current');
            setOrg(response.organization);
        }
        catch (err) {
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    }, []);
    const save = useCallback(async (updates) => {
        if (!org) {
            return;
        }
        setSaving(true);
        setError(null);
        try {
            const response = await apiFetch(`/api/organizations/${org.id}`, {
                method: 'PUT',
                body: JSON.stringify({ organization: updates }),
            });
            setOrg(response.organization);
            notify('Success', 'Update successful.', 'success');
        }
        catch (err) {
            const message = err.message;
            setError(message);
            notify('Error', message || 'An error occurred while saving.', 'error');
        }
        finally {
            setSaving(false);
        }
    }, [org, notify]);
    useEffect(() => { load(); }, [load]);
    return { org, loading, saving, error, save, reload: load };
}
